import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import Swal from "sweetalert2";

import { Discussion, Profile, Invite, User } from "../../../../../models";
import {
  ProfileService,
  InviteService,
  UserService,
} from "../../../../../services";

@Component({
  selector: "invite-to-discussion-form",
  templateUrl: "./invite-to-discussion-form.component.html",
  styleUrls: [
    "./invite-to-discussion-form.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class InviteToDiscussionForm implements OnInit {
  private defaultUserImg: string =
    "../../../../../../../assets/images/uMuzi/african-mask.png";
  public currentUser: User;
  public profile: Profile = null;
  public inviteFriendField = new FormControl();
  public newInvite: Invite;
  public existingInvite: Invite = null;
  public errors: Object = {};
  public isSubmitting: boolean = false;
  public visible = false;
  public visibleAnimate = false;
  @Input() discussion: Discussion;
  @Output() hide = new EventEmitter<any>();

  constructor(
    private profileService: ProfileService,
    private inviteService: InviteService,
    private userService: UserService
  ) {
    this.trackFoundProfiles();
  }

  public trackFoundProfiles() {
    this.inviteFriendField.valueChanges.subscribe((value) => {
      this.existingInvite = null;
      if (value.length > 0) {
        this.isSubmitting = true;
        this.searchProfile(value);
      }
    });
  }

  ngOnInit() {
    this.getUser();
  }

  public getUser() {
    this.userService.currentUser.subscribe((userData: User) => {
      this.currentUser = userData;
    });
  }

  public searchProfile(value: string) {
    this.profileService.searchOne(value).subscribe(
      (profile) => {
        this.isSubmitting = false;
        this.profile = profile.profiles[0];

        if (this.profile !== undefined && this.profile !== null) {
          this.checkInvite();
        }
      },
      (err) => {
        this.errors = err;
        this.isSubmitting = false;
      }
    );
  }

  public checkInvite() {
    this.existingInvite = null;

    var invite = new Invite();
    invite.sender = this.currentUser.username;
    invite.recipient = this.profile.username;
    invite.status = "requested";
    invite.target = this.discussion.slug;
    invite.targetModel = "Discussion";
    invite.community = this.discussion.community.name;

    this.newInvite = invite;
    this.isSubmitting = true;

    this.inviteService.checkOne(invite).subscribe(
      (invite) => {
        this.existingInvite = invite;
        this.isSubmitting = false;
      },
      (err) => {
        this.errors = err;
        this.isSubmitting = false;
      }
    );
  }

  public sendInvite(successMsg, errorMsg) {
    this.isSubmitting = true;

    // post the invite
    this.inviteService.saveOne(this.newInvite).subscribe(
      (invite) => {
        this.profile = null;
        this.hide.emit();
        this.fireSuccessAlert(successMsg);
      },
      (err) => {
        this.errors = err;
        this.isSubmitting = false;
        this.fireErrorAlert(errorMsg);
      }
    );
  }

  public openDiscussionInviteConfirmation() {
    var title, text, successMsg, errorMsg;

    if (!this.existingInvite) {
      title = "Send invite";
      text = "Invite " + this.profile.username + " to join this nDaba?";
      successMsg = "Invite sent to " + this.profile.username;
      errorMsg = "There were errors sending your invitation.";
    } else if (this.existingInvite) {
      title = "Revoke invite";
      text = "Revoke invite sent to " + this.profile.username;
      successMsg = "Invite to " + this.profile.username + " revoked";
      errorMsg = "There were errors revoking your invitation.";
    }

    Swal.fire({
      title: title,
      text: text,
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Haai, cancel!",
      confirmButtonText: "Yebo, send!",
    }).then((result) => {
      if (result.value) {
        if (this.profile !== undefined && this.profile !== null) {
          this.sendInvite(successMsg, errorMsg);
        }
        return;
      }
    });
  }

  public fireSuccessAlert(successMsg) {
    Swal.fire("Done!", successMsg, "success");
  }

  public fireErrorAlert(errorMsg) {
    Swal.fire("Eish!", errorMsg, "warning");
    window.scrollTo(0, 0);

    function errorAlert() {
      Swal.close();
    }
    setTimeout(errorAlert, 3000);
  }
}
